import React, { useRef, useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import profileIcon from "../../assets/images/users/user-dummy-img.jpg";
import { getUserProfile } from "../../Common/data/getUserProfile";

const ProfileImage = () => {
    const [profilePicture, setProfilePicture] = useState("");
    const fileInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        // Fetch user profile data when the component mounts
        const fetchUserProfile = async () => {
            try {
                const userData = await getUserProfile();
                setProfilePicture(userData.results.profile_image_url);
            } catch (error: any) {
                console.error("Error fetching user profile:", error.message);
            }
        };

        fetchUserProfile();
    }, []);

    const handleUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Card className="mb-4">
            <Card.Body className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <div className="profile-image-container" onClick={handleUploadClick}>
                        <img
                            src={profilePicture || profileIcon}
                            alt="Profile"
                            height="100"
                            className="profile-image"
                        />
                    </div>
                    {/* Hidden file input */}
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={() => {}} // Placeholder for potential future use
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default ProfileImage;
